import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {VtSSOService} from './vt-sso.service';

@Injectable({
  providedIn: 'root'
})
export class VtSSOAuthGuardService implements CanActivate {
  constructor(private vtSSOService: VtSSOService) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

      return true
    const ticketId = localStorage.getItem(VtSSOService.requestParamTicketKey);
    if (ticketId) {
      return true;
    }
    this.vtSSOService.redirectToLogin();
    return Promise.resolve(false);
  }
}
